import { Tooltip } from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

const PrivateClientGroupIcon = () => (
  <Tooltip title="Private group, visible only to NPM">
    <AdminPanelSettingsIcon
      fontSize="small"
      color="action"
      sx={{ ml: 0.5, verticalAlign: "middle" }}
    />
  </Tooltip>
);

export default PrivateClientGroupIcon;
